module.exports = __webpack_public_path__ + "7dcc7e88e204ffb310d8e03db2587565.svg";